// extracted by mini-css-extract-plugin
export default {"incrementor":"Incrementor_incrementor__D3Cup","value":"Incrementor_value__C+tAt","button":"Incrementor_button__1Z-8Y","hideLabel":"Incrementor_hideLabel__ZriBr"};